@import '../../../../../constants/spacing.module.less';

.settings-api-key-empty {
  display: flex;
  justify-content: space-between;
}

.settings-api-key-v2-wrapper {
  padding: @space-0 @space-16 @space-16;
}
